import { Image } from 'components/Image'
import PropTypes from 'prop-types'
import React from 'react'
import getStyleComponentUtil from 'modules/component/utils/get-style'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import useSelector from 'modules/component/utils/hooks/useSelector.js'

/**
 * @param style
 * @param source
 * @param alt
 * @param isHorizontal
 * @param title
 * @param width
 * @param isVeryTall
 * @param aspectRatio
 * @param isBig
 * @param shouldLazyLoad
 * @returns {JSX.Element}
 * @constructor
 */
export function ItemImage ({
  style = {},
  source,
  alt,
  isHorizontal,
  title,
  width,
  isVeryTall,
  aspectRatio,
  shouldLazyLoad,
  isBig
}) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const styleToExtend = {
    maxWidth: isBig && !isSmallScreen
      ? undefined
      : '100%'
  }

  return (
    <div
      style={getStyleComponentUtil({
        position: 'relative',
        lineHeight: '0',
        width: '100%'
      }, style)}
    >
      <Image
        alt={alt || title}
        title={title}
        src={source}
        isHorizontal={isHorizontal}
        aspectRatio={aspectRatio}
        isVeryTall={isVeryTall}
        width={width}
        shouldLazyLoad={shouldLazyLoad}
        style={getStyleComponentUtil(styleToExtend, style)}
      />
    </div>
  )
}

ItemImage.propTypes = {
  style: PropTypes.object,
  source: PropTypes.string.isRequired,
  alt: PropTypes.string,
  isHorizontal: PropTypes.bool,
  title: PropTypes.string.isRequired,
  width: PropTypes.string,
  isSmallScreen: PropTypes.bool,
  isVeryTall: PropTypes.bool,
  isBig: PropTypes.bool
}

ItemImage.ASPECT_RATIO = Image.ASPECT_RATIO
